import script from "./TileCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./TileCard.vue?vue&type=script&setup=true&lang=ts"

import "./TileCard.vue?vue&type=style&index=0&id=0dedc6de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dedc6de"]])

export default __exports__